import { render, staticRenderFns } from "./StepThreeForm.vue?vue&type=template&id=fabe857a"
import script from "./StepThreeForm.vue?vue&type=script&lang=ts"
export * from "./StepThreeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports